export default __webpack_public_path__ + "static/hr-85eb7e0d4ea914241924c0b0321f34e2.svg";